import { gql } from '@apollo/client';

export const INBOX_ITEM_FIELDS = gql`
  fragment InboxItemFields on InboxItem {
    id
    ownerId
    ownerType
    relevantObjectId
    relevantObjectType
    readAt
    title
    message
    actionLink
    createdAt
  }
`;

export const GET_UNREAD_INBOX_ITEMS_FOR_OWNER = gql`
  ${INBOX_ITEM_FIELDS}
  query GetInboxForOwner($ownerId: String!) {
    getInboxForOwner(ownerId: $ownerId, unreadOnly: true) {
      ...InboxItemFields
    }
  }
`;

export const GET_INBOX_ITEM = gql`
  ${INBOX_ITEM_FIELDS}
  query GetInboxItem($id: String!) {
    getInboxItem(id: $id) {
      ...InboxItemFields
    }
  }
`;

export const MARK_INBOX_ITEM_AS_READ = gql`
  mutation MarkInboxItemAsRead($id: String!) {
    markInboxItemAsRead(id: $id)
  }
`;
